// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.e5LZFj7edvnuic {
  flex-basis: 100%;
  margin: 2px 0;
  padding-left: 12px;
  color: var(--accent-text, var(--ds-text-subtlest, #626f86));
  line-height: 16px;
}
.RB2QdwEYVbzS26 {
  order: 2;
  margin-top: 4px;
  margin-bottom: 0;
  color: var(--accent-text, var(--ds-text-subtlest, #626f86));
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filteredCardCount": `e5LZFj7edvnuic`,
	"collapsedCardCount": `RB2QdwEYVbzS26`
};
export default ___CSS_LOADER_EXPORT___;
